import './App.css';
import { NextUIProvider } from '@nextui-org/react';
import Router from './RouterApp';
import { ToastContainer  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useThemes } from './Hooks/useThemes';

function App() {
  const [theme, toggleTheme] = useThemes();

  return (
    <div className="App">
      <NextUIProvider theme={theme}>
        <ToastContainer />
        <Router />
      </NextUIProvider>
    </div>
  );
}

export default App;
